// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"dd91b1ab","453":"c55be196"}[chunkId] + ".chunk.js";
};